import React, { memo } from 'react';
import { ProductCardSkeleton } from './ProductCardSkeleton';

const ProductListSkeleton = memo(function ProductListSkeleton({ count = 6, columns = 3, gap = 20, style = {} }) {
  const gridClass = columns === 4 ? 'grid-1-2-4' : columns === 2 ? 'grid-1-2' : 'grid-1-2-3';
  return (
    <div className={gridClass} style={{ gap, width: '100%', ...style }} aria-busy="true">
      {Array.from({ length: count }).map((_, idx) => (
        <ProductCardSkeleton key={idx} />
      ))}
    </div>
  );
});

export default ProductListSkeleton;
